import autoBind from 'auto-bind'

import { InitPaymentRequest, KeyInfo, PaymentInfo, PayTransaction } from 'api/domain/transactions'
import { AppApiBase } from 'api/core/AppApiBase'
import { paymentHeaders } from 'utils'
import { LegalInfo } from 'api/domain/app'

export class PublicApi {
  constructor(protected api: AppApiBase) {
    autoBind(this)
  }

  async getTransaction(id: PayTransaction['id']) {
    return this.api.get<PayTransaction>(`/p/${id}`)
  }

  async cancelTransaction(id: PayTransaction['id']): Promise<PayTransaction> {
    return this.api.delete<PayTransaction>(`/p/${id}`)
  }

  async getPaymentInfo(id: PayTransaction['id'], data?: InitPaymentRequest) {
    return this.api.get<PaymentInfo>(`/p/${id}/payment`, data, { headers: paymentHeaders() })
  }

  async getPublicKey() {
    return this.api.get<KeyInfo>('/p/key')
  }

  async legalInfo() {
    return this.api.get<LegalInfo>('/info/legal-info')
  }
}
